/**
 * Central configuration for the site.
 * Update the affiliate link here to apply it everywhere at once.
 */
export const SITE_CONFIG = {
  name: 'Wie kauft man Bitcoin',
  tagline: 'Die #1 Anlaufstelle für Bitcoin-Einsteiger in Deutschland',
  canonicalUrl: 'https://www.wie-kauft-man-bitcoin.de',

  affiliate: {
    link: 'https://accounts.binance.com/register?ref=YSY8VOEH',
    discountPercent: 10,
    platform: 'Binance',
    ctaLabel: 'Jetzt 10% Rabatt sichern',
    ctaLabelShort: '10% Rabatt sichern',
  },

  contact: {
    email: 'info@wie-kauft-man-bitcoin.de',
  },
};
